/**
 * Chess Not Checcers — storefront interactions
 */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* Reveal on scroll */
  function initReveal() {
    var els = document.querySelectorAll('.cnc-rev:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* Mobile nav toggle */
  function initMobileNav() {
    var toggle = document.querySelector('[data-cnc-menu-toggle]');
    var panel = document.querySelector('[data-cnc-mobile-nav]');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () {
      var open = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Cart count badge */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cnc-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? String(count) : '';
      el.hidden = count < 1;
    });
  }

  function fetchCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count || 0); })
      .catch(function () {});
  }

  /* Quick add from product cards */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cnc-quick-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = 'Adding…';
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Add failed');
          return r.json();
        })
        .then(function () {
          btn.textContent = 'Added';
          fetchCartCount();
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cnc:cart:open'));
          setTimeout(function () {
            btn.textContent = original;
            btn.disabled = false;
          }, 1200);
        })
        .catch(function () {
          btn.textContent = 'Error';
          setTimeout(function () {
            btn.textContent = original;
            btn.disabled = false;
          }, 1200);
        });
    });
  }

  /* Collection filter chips (client-side tag filter) */
  function initCollectionFilters() {
    var root = document.querySelector('[data-cnc-collection-grid]');
    if (!root) return;
    var chips = root.querySelectorAll('[data-cnc-filter]');
    var prods = root.querySelectorAll('[data-cnc-product-tags]');
    var countEl = root.querySelector('[data-cnc-count]');
    if (!chips.length || !prods.length) return;

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('on'); });
        chip.classList.add('on');
        var f = chip.getAttribute('data-cnc-filter') || 'all';
        var n = 0;
        prods.forEach(function (p) {
          var tags = (p.getAttribute('data-cnc-product-tags') || '').toLowerCase().split(/\s+/);
          var show = f === 'all' || tags.indexOf(f.toLowerCase()) !== -1;
          p.style.display = show ? '' : 'none';
          if (show) n++;
        });
        if (countEl) {
          countEl.textContent = n + (n === 1 ? ' Piece' : ' Pieces');
        }
      });
    });
  }

  /* Collection sort */
  function initCollectionSort() {
    var select = document.querySelector('[data-cnc-sort]');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      if (select.value) {
        url.searchParams.set('sort_by', select.value);
      } else {
        url.searchParams.delete('sort_by');
      }
      window.location.href = url.toString();
    });
  }

  /* PDP */
  function initProduct() {
    var root = document.querySelector('[data-cnc-product]');
    if (!root) return;

    var productJson = root.querySelector('[data-cnc-product-json]');
    var product = null;
    try {
      product = productJson ? JSON.parse(productJson.textContent) : null;
    } catch (e) {
      product = null;
    }

    var form = root.querySelector('[data-cnc-product-form]');
    var variantInput = root.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-cnc-price]');
    var addBtn = root.querySelector('[data-cnc-add]');
    var sticky = root.querySelector('[data-cnc-sticky-buy]');
    var stickyBtn = root.querySelector('[data-cnc-sticky-add]');
    var stickyMeta = root.querySelector('[data-cnc-sticky-meta]');
    var qtyInput = root.querySelector('[data-cnc-qty]');
    var qtyDisplay = root.querySelector('[data-cnc-qty-display]');
    var mainImg = root.querySelector('[data-cnc-main-media]');
    var viewLabel = root.querySelector('[data-cnc-view-label]');
    var colorName = root.querySelector('[data-cnc-color-name]');
    var sizeName = root.querySelector('[data-cnc-size-name]');

    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      var amount = (Number(cents) / 100).toFixed(2);
      return moneyFormat
        .replace('{{amount_no_decimals}}', String(Math.round(Number(cents) / 100)))
        .replace('{{amount}}', amount)
        .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
    }

    /* Gallery thumbs */
    root.querySelectorAll('[data-cnc-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('[data-cnc-thumb]').forEach(function (t) {
          t.classList.remove('on');
        });
        thumb.classList.add('on');
        var src = thumb.getAttribute('data-src');
        var label = thumb.getAttribute('data-view') || '';
        if (mainImg && src) {
          var img = mainImg.querySelector('img');
          if (img) {
            img.src = src;
            img.srcset = '';
          } else {
            mainImg.innerHTML = '';
            var fill = document.createElement('div');
            fill.className = 'cnc-fill';
            mainImg.appendChild(fill);
            var newImg = document.createElement('img');
            newImg.src = src;
            newImg.alt = product ? product.title : '';
            mainImg.appendChild(newImg);
          }
          var note = mainImg.querySelector('.cnc-photo-note');
          if (note) note.style.display = 'none';
          var piece = mainImg.querySelector('.cnc-piece');
          if (piece) piece.style.display = 'none';
        }
        if (viewLabel) viewLabel.textContent = label;
      });
    });

    /* Accordion */
    root.querySelectorAll('[data-cnc-acc-head]').forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('.cnc-acc-item');
        if (!item) return;
        var wasOpen = item.classList.contains('open');
        root.querySelectorAll('.cnc-acc-item').forEach(function (i) {
          i.classList.remove('open');
        });
        if (!wasOpen) item.classList.add('open');
      });
    });

    /* Quantity */
    var qty = 1;
    function syncQty() {
      if (qtyDisplay) qtyDisplay.textContent = String(qty);
      if (qtyInput) qtyInput.value = String(qty);
      updateAddLabel();
    }

    root.querySelectorAll('[data-cnc-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (qty > 1) qty--;
        syncQty();
      });
    });
    root.querySelectorAll('[data-cnc-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        qty++;
        syncQty();
      });
    });

    function selectedOptions() {
      var opts = {};
      root.querySelectorAll('[data-cnc-option]').forEach(function (group) {
        var name = group.getAttribute('data-cnc-option');
        var on = group.querySelector('.on, [aria-pressed="true"]');
        if (on) opts[name] = on.getAttribute('data-value') || on.textContent.trim();
      });
      return opts;
    }

    function findVariant(opts) {
      if (!product || !product.variants) return null;
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) {
          var key = product.options[i];
          return !opts[key] || opts[key] === o;
        });
      });
    }

    function updateAddLabel() {
      if (!addBtn || !product) return;
      var variant = findVariant(selectedOptions()) || product.variants[0];
      if (!variant) return;
      var price = formatMoney(variant.price * qty);
      if (variant.available) {
        addBtn.disabled = false;
        addBtn.textContent = 'Add To Cart — ' + price;
      } else {
        addBtn.disabled = true;
        addBtn.textContent = 'Sold Out';
      }
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (variantInput) variantInput.value = variant.id;
      if (stickyMeta) {
        var parts = [formatMoney(variant.price)];
        if (variant.option1) parts.push(variant.option1);
        if (variant.option2) parts.push(variant.option2);
        stickyMeta.textContent = parts.join(' · ');
      }
    }

    /* Option picks */
    root.querySelectorAll('[data-cnc-option]').forEach(function (group) {
      group.querySelectorAll('[data-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('[data-value]').forEach(function (b) {
            b.classList.remove('on');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('on');
          btn.setAttribute('aria-pressed', 'true');
          var name = group.getAttribute('data-cnc-option') || '';
          if (/color|colour/i.test(name) && colorName) {
            colorName.textContent = btn.getAttribute('data-value') || btn.textContent.trim();
          }
          if (/size/i.test(name) && sizeName) {
            sizeName.textContent = btn.getAttribute('data-value') || btn.textContent.trim();
          }
          updateAddLabel();
        });
      });
    });

    /* Sticky buy bar */
    var buyRow = root.querySelector('.cnc-buy-row');
    if (sticky && buyRow) {
      window.addEventListener(
        'scroll',
        function () {
          var past = buyRow.getBoundingClientRect().bottom < 0;
          sticky.classList.toggle('show', past);
        },
        { passive: true }
      );
    }

    function addToCart(e) {
      if (e) e.preventDefault();
      if (!form || !variantInput) return;
      var formData = new FormData(form);
      fetch(form.action || '/cart/add', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      })
        .then(function (r) {
          if (!r.ok) throw new Error('fail');
          return r.json();
        })
        .then(function () {
          fetchCartCount();
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cnc:cart:open'));
          if (addBtn) {
            addBtn.textContent = 'Added';
            setTimeout(function () { updateAddLabel(); }, 1000);
          }
        })
        .catch(function () {
          form.submit();
        });
    }

    if (form) {
      form.addEventListener('submit', addToCart);
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', addToCart);
    }

    updateAddLabel();
  }

  /* Cart drawer */
  function money(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
      }
    } catch (e) {}
    var n = (Number(cents) / 100).toFixed(2);
    return '$' + n;
  }

  function initCartDrawer() {
    var root = document.querySelector('[data-cnc-drawer]');
    if (!root) return;
    var body = root.querySelector('[data-cnc-drawer-body]');
    var foot = root.querySelector('[data-cnc-drawer-foot]');
    var countEl = root.querySelector('[data-cnc-drawer-count]');
    var subEl = root.querySelector('[data-cnc-drawer-subtotal]');
    var moneyFormatEl = document.querySelector('[data-money-format]');
    var moneyFormat = moneyFormatEl ? moneyFormatEl.getAttribute('data-money-format') : null;

    function formatMoney(cents) {
      if (window.Shopify && Shopify.formatMoney && moneyFormat) {
        return Shopify.formatMoney(cents, moneyFormat);
      }
      return money(cents);
    }

    function openDrawer() {
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cnc-drawer-open');
      document.body.classList.add('cnc-drawer-open');
    }

    function closeDrawer() {
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cnc-drawer-open');
      document.body.classList.remove('cnc-drawer-open');
    }

    function lineHtml(item) {
      var img = item.image
        ? '<img src="' + item.image + '" alt="" width="72" height="90" loading="lazy">'
        : '<span class="cnc-drawer__piece-fallback"></span>';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="cnc-drawer__var">' + item.variant_title + '</div>'
        : '';
      return (
        '<li class="cnc-drawer__item" data-cnc-line-key="' + item.key + '">' +
          '<a class="cnc-drawer__thumb" href="' + item.url + '">' + img + '</a>' +
          '<div class="cnc-drawer__meta">' +
            '<a class="cnc-drawer__title" href="' + item.url + '">' + item.product_title + '</a>' +
            variant +
            '<div class="cnc-drawer__price">' + formatMoney(item.final_line_price) + '</div>' +
            '<div class="cnc-drawer__qty">' +
              '<button type="button" data-cnc-line-qty="' + item.key + '" data-delta="-1" aria-label="Decrease">−</button>' +
              '<span data-cnc-line-qty-display>' + item.quantity + '</span>' +
              '<button type="button" data-cnc-line-qty="' + item.key + '" data-delta="1" aria-label="Increase">+</button>' +
              '<button type="button" class="cnc-drawer__remove" data-cnc-line-remove="' + item.key + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</li>'
      );
    }

    function emptyHtml() {
      return (
        '<div class="cnc-drawer__empty" data-cnc-drawer-empty>' +
          '<p>Your cart is empty. Build a position first.</p>' +
          '<a class="cnc-btn" href="/collections/all" data-cnc-drawer-close>Shop The Drop</a>' +
        '</div>'
      );
    }

    function renderCart(cart) {
      updateCartCount(cart.item_count || 0);
      if (countEl) {
        countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
      }
      if (subEl) subEl.textContent = formatMoney(cart.total_price || 0);
      if (foot) foot.hidden = !cart.item_count;
      if (!body) return;
      if (!cart.item_count) {
        body.innerHTML = emptyHtml();
        return;
      }
      body.innerHTML =
        '<ul class="cnc-drawer__items" data-cnc-drawer-items">' +
        (cart.items || []).map(lineHtml).join('') +
        '</ul>';
    }

    function fetchCart() {
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCart(cart);
          return cart;
        });
    }

    function changeLine(key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('change failed');
          return r.json();
        })
        .then(function (cart) {
          renderCart(cart);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
    }

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-cnc-cart-open]');
      if (openBtn) {
        e.preventDefault();
        fetchCart().then(openDrawer);
        return;
      }
      if (e.target.closest('[data-cnc-drawer-close]')) {
        closeDrawer();
        return;
      }
      var qtyBtn = e.target.closest('[data-cnc-line-qty]');
      if (qtyBtn && root.contains(qtyBtn)) {
        var key = qtyBtn.getAttribute('data-cnc-line-qty');
        var delta = Number(qtyBtn.getAttribute('data-delta') || 0);
        var row = qtyBtn.closest('[data-cnc-line-key]');
        var display = row && row.querySelector('[data-cnc-line-qty-display]');
        var current = display ? Number(display.textContent || 1) : 1;
        var next = Math.max(0, current + delta);
        changeLine(key, next);
        return;
      }
      var removeBtn = e.target.closest('[data-cnc-line-remove]');
      if (removeBtn && root.contains(removeBtn)) {
        changeLine(removeBtn.getAttribute('data-cnc-line-remove'), 0);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) closeDrawer();
    });

    document.addEventListener('cnc:cart:open', function () {
      fetchCart().then(openDrawer);
    });

    document.addEventListener('cart:refresh', function () {
      fetchCart();
    });
  }

  /* Cart page quantity helpers */
  function initCartPage() {
    var page = document.querySelector('[data-cnc-cart-page]');
    if (!page) return;
    page.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cnc-line-qty]');
      if (!btn || !page.contains(btn)) return;
      var key = btn.getAttribute('data-cnc-line-qty');
      var delta = Number(btn.getAttribute('data-delta') || 0);
      var input = page.querySelector('[data-cnc-line-input="' + key + '"]');
      if (!input) return;
      var next = Math.max(0, Number(input.value || 0) + delta);
      input.value = next;
    });
  }

  onReady(function () {
    document.body.classList.add('cnc-theme');
    initReveal();
    initMobileNav();
    fetchCartCount();
    initQuickAdd();
    initCollectionFilters();
    initCollectionSort();
    initProduct();
    initCartDrawer();
    initCartPage();
  });
})();
